import { render, staticRenderFns } from "./DeclaracaoVinculoExclusaoModal.vue?vue&type=template&id=49b7f2ec&"
import script from "./DeclaracaoVinculoExclusaoModal.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoVinculoExclusaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports